import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Task, TaskCode } from 'src/app/models';
import { ITaskForm } from 'src/app/models/domain/task-form.model';

@Injectable({ providedIn: 'root' })
export class DevelopmentNoveltyFormService {
  public constructor(private readonly fb: FormBuilder) {}

  public createFormGroup(task: Task): FormGroup<ITaskForm> {
    return this.fb.group({
      actualFinishDate: this.fb.control(
        task.actualFinishDate ?? null, // eslint-disable-line no-null/no-null
        {
          validators: [(control) => Validators.required(control)],
          nonNullable: false,
        }
      ),
      id: this.fb.control(task.id, { nonNullable: true }),
      isLockBom: this.fb.control(task.process === (TaskCode.C47 as string), {
        nonNullable: true,
      }),
    });
  }

  public adaptToDomain(formGroup: FormGroup<ITaskForm>): Partial<Task> {
    const { actualFinishDate, id } = formGroup.value;

    return {
      actualFinishDate: actualFinishDate ?? undefined,
      id: id ?? undefined,
    };
  }
}
